<template>
  <div>
    <v-layout xs12>
      <v-carousel>
        <v-carousel-item 
          v-for="(slide, i) in slides"
          :key="i"
          :src="slide.file">
          <h1>{{ slide.title }}</h1>
          <router-link :to="slide.to">{{ slide.subtitle }}</router-link>
        </v-carousel-item>
      </v-carousel>
    </v-layout>
    <v-container>
      <v-layout justify-center row wrap>
        <v-flex sm12 md6 v-for="(service, key) in services" :key="key">
          <v-container>
            <v-toolbar
              dark
              color="grey lighten-2">
              <v-icon :class="['fas', service.icon]"></v-icon>
              <v-toolbar-title>{{ service.title }}</v-toolbar-title>
            </v-toolbar>
            <v-card>
              <v-card-text fluid>
                <p style="min-height: 125px;">{{ service.excerpt }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn flat color="primary" :to="service.to">Learn more...</v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'home',
    data () {
      return {
        slides: [
          {
            file: '/static/bigstock-Group-Of-Business-People-Worki-250285747.jpg',
            title: 'business development',
            subtitle: 'Maximize the effectiveness of your organization’s business development efforts',
            to: '/topics/business'
          },
          {
            file: '/static/bigstock-African-Woman-Raising-Hand-To--229502425.jpg',
            title: 'performance consulting',
            subtitle: 'Identify the root cause of the performance problem and the appropriate intervention',
            to: '/evaluation'
          },
          {
            file: '/static/bigstock-Confident-mature-businessman-g-217694641.jpg',
            title: 'evaluate your effectiveness',
            subtitle: 'Make the training stick and get a return on the training investment',
            to: '/services#evaluation'
          },
          {
            file: '/static/bigstock-Happy-Smiling-Corporate-Team-O-230283016.jpg',
            title: 'customized training',
            subtitle: 'Generic training creates little to no return on the dollar invested',
            to: '/topics'
          }
        ],
        services: [
          {
            title: 'Business Development/Sales',
            icon: 'fa-university',
            excerpt: 'If growth is an important factor to your organization, InterAct Training Group can provide your employees scaled business development training.  Whether they are brand new and need to create a healthy paradigm about business development, or whether they are tenured and quite successful in this arena, ITG has courses that will help them grow and facilitate the organization’s growth.  Click here to see a sampling of the courses available.',
            to: '/topics/business'
          },
          {
            title: 'Leadership Development',
            icon: 'fa-hand-point-right',
            excerpt: 'To successfully achieve growth every organization needs to develop leaders.  Leaders influence employees to do the right things, and impact the organization’s culture and ability to recruit and retain good talent.  InterAct Training Group has a variety of courses developed in this topic area.  Click here to see a sampling of the courses that are available.',
            to: '/topics/leadership'
          },
          {
            title: 'Team Development',
            icon: 'fa-users',
            excerpt: 'One significant, sustainable, competitive advantage that organizations should focus on is creating cohesive teams.  Cohesive teams get more done with less effort than teams that aren’t cohesive.  Click here to read about InterAct Training Group’s approach to team development.',
            to: '/topics/team'
          },
          {
            title: 'Management Development',
            icon: 'fa-user-tie',
            excerpt: 'There are many different management skills that are needed for effectiveness in an organization.  The type of skills that a newly promoted manager/supervisor might need to learn could be quite different than a more experienced, tenured manager.  Click here to learn about a variety of management skill topics that InterAct Training Group has developed.',
            to: '/topics/management'
          }
        ]
      }
    },
    methods: {
      formatDate (date) {
        return moment(date).format('L')
      }
    }
  }
</script>

<style>
  .v-carousel {
    height: 500px;
  }
  .v-responsive__content h1 {
    position: absolute;
    right: 0;
    padding: 10px;
    background: rgba(255,255,255,0.5);
    width: 100%;
    z-index: 1;
    color: #FFFFFF;
    text-shadow: 2px 2px 4px #000000;
    bottom: 22%;
    letter-spacing: 0;
    font-size: 1.5em;
  }
  @media all and (min-width: 480px) {
    .v-responsive__content h1 {
      bottom: 20%;
      letter-spacing: .25em;
      font-size: 1.5em;
    }
  }
  .v-responsive__content a {
    display: block;
    background: rgba(152,43,45,0.5);
    width: 100%;
    padding: 10px;
    position: absolute;
    right: 0;
    z-index: 1;
    color: #FFFFFF;
    bottom: 50px;
    text-align: right;
    font-size: 1em;
    text-decoration: none;
    letter-spacing: normal;
    cursor: pointer;
  }
  @media all and (min-width: 480px) {
    .v-responsive__content a {
      font-size: 1.25em;
    }
  }
  .v-toolbar__title {
    font-size: 1.15em;
  }
  @media all and (min-width: 480px) {
    .v-toolbar__title {
      font-size: 20px;
    }
  }
  .v-responsive__content a:hover {
    background: rgba(152,43,45,0.8);
  }
  .v-list__tile__title a {
    text-decoration: none;
    font-weight: 600;
    color: #D32F2F;
  }
  .v-list__tile__title a:hover {
    text-decoration: underline;
    color: #982b2d;
  }
  @media all and (min-width: 600px) {
    .v-carousel {
      height: 480px;
    }
    .v-jumbotron__content h1 {
      font-size: 2em;
      letter-spacing: .25em;
      bottom: 20%;
    }
    .v-jumbotron__content p {
      font-size: 1.25em;
      bottom: 10%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue